import { createContext, useContext, useMemo, type ReactNode } from "react";

/**
 * Width of the aside docked to the right edge of the viewport (the Tower
 * Assistant), or 0 while it is closed. Right-anchored overlays such as the
 * bond detail drawer shift left by this much instead of covering the aside.
 * Trees without a provider behave as if nothing is docked.
 */
const DockedAsideOffsetContext = createContext(0);

export function DockedAsideProvider({
  open,
  width,
  children,
}: Readonly<{ open: boolean; width: number; children: ReactNode }>) {
  const offset = useMemo(() => (open ? width : 0), [open, width]);
  return <DockedAsideOffsetContext.Provider value={offset}>{children}</DockedAsideOffsetContext.Provider>;
}

export function useDockedAsideOffset(): number {
  return useContext(DockedAsideOffsetContext);
}
